<div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <!-- Title and breadcrumb pair up on one row so the buttons below get the full
         width to themselves on narrow screens instead of being wedged beside the
         crumb — which is what left them mismatched widths and stacked oddly. -->
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 sm:justify-start sm:gap-6">
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">Settings</h2>
        <nav>
            <ol class="flex items-center gap-1.5">
                <li>
                    <a routerLink="/" class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400" href="/">
                        Home
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-current">
                            <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </li>
                <li class="text-sm text-gray-800 dark:text-white/90">Setting</li>
            </ol>
        </nav>
    </div>

    <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-3">
        <app-button variant="outline" size="sm" className="w-full sm:w-auto whitespace-nowrap"
            (click)="openEmailModal()">Change Email Address</app-button>
        <app-button size="sm" className="w-full sm:w-auto whitespace-nowrap"
            (click)="openPasswordModal()">Change Password</app-button>
    </div>
</div>

<div class="space-y-6">
    <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="border-b border-gray-200 px-6 py-4 dark:border-gray-800">
            <h2 class="text-lg font-medium text-brand-500 dark:text-white">Personal Information</h2>
        </div>

        <div class="p-4 sm:p-6 dark:border-gray-800">
            <form>
                <div class="grid grid-cols-1 gap-5 md:grid-cols-2">

                    <div>
                        <app-lable for="user-name">User Name</app-lable>
                        <app-input-field [(ngModel)]="userName" name="userName" placeholder="Enter your user name" [disabled]="true">
                        </app-input-field>
                    </div>

                    <div>
                        <app-lable for="display-name">Display Name</app-lable>
                        <app-input-field [(ngModel)]="displayName" name="displayName" placeholder="Enter your display name">
                        </app-input-field>
                    </div>

                    <!-- Current Email (read-only) -->
                    <div>
                        <app-lable>Email Address</app-lable>
                        <div class="relative">
                            <app-input-field [ngModel]="currentEmail" name="currentEmail" [disabled]="true" placeholder="Your email address">
                            </app-input-field>
                            <button type="button" (click)="openEmailModal()"
                                class="absolute right-3 top-1/2 -translate-y-1/2 text-xs font-semibold text-[#D31148] hover:underline">
                                Change
                            </button>
                        </div>
                    </div>

                    <div class="col-span-full">
                        <div class="grid grid-cols-1 gap-5 sm:grid-cols-3">

                            <!-- Gender and Attracted To moved to the new "Preferences" screen
                                 (Dashboard > Settings > Preferences) — see preferences.html -->
                            <div>
                                <app-lable for="status">Status</app-lable>
                                <app-select [options]="statusOptions" [(ngModel)]="selectedStatus" name="status" className="dark:bg-dark-900">
                                </app-select>
                            </div>

                        </div>
                    </div>

                    <div class="col-span-full">
                        <div class="flex items-center justify-between mb-2">
                            <app-lable for="bio">Bio</app-lable>
                            <span class="text-sm text-gray-500 dark:text-gray-400">Max number of characters is {{ maxBioLength }}</span>
                        </div>
                        <div class="relative" data-bio-emoji-section>
                            <app-text-area #bioTextArea [(ngModel)]="bio" name="bio" [rows]="6" placeholder="Please enter your bio" (ngModelChange)="validateBio()">
                            </app-text-area>
                            <button #bioEmojiBtn type="button"
                                class="absolute flex items-center justify-center text-gray-400 rounded-full bottom-2 right-2 size-7 hover:text-gray-600 hover:bg-gray-100 dark:hover:text-gray-300 dark:hover:bg-white/5"
                                (click)="toggleBioEmojiPicker(bioEmojiBtn); $event.stopPropagation()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                                    <line x1="9" y1="9" x2="9.01" y2="9"></line>
                                    <line x1="15" y1="9" x2="15.01" y2="9"></line>
                                </svg>
                            </button>
                            <app-emoji-picker [isOpen]="showBioEmojiPicker" [anchorTop]="bioEmojiDDPos.top" [anchorLeft]="bioEmojiDDPos.left"
                                anchorPosition="absolute" (pick)="pickBioEmoji($event)">
                            </app-emoji-picker>
                        </div>
                        <div class="flex justify-between mt-2">
                            <span class="text-sm" [class.text-red-500]="bio.length > maxBioLength" [class.text-gray-500]="bio.length <= maxBioLength">
                                {{ bio.length || 0 }}/{{ maxBioLength }}
                            </span>
                            <span *ngIf="bioError" class="text-sm text-red-500">{{ bioError }}</span>
                        </div>
                    </div>

                </div>

                <!-- Update sits at the end of the form it submits, right-aligned. -->
                <div class="mt-6 flex justify-end border-t border-gray-200 pt-5 dark:border-gray-800">
                    <app-button variant="primary" className="w-full sm:w-auto" (click)="updateProfile()">
                        {{ loading ? 'Updating...' : 'Update' }}
                    </app-button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- ── Change Email Modal ──────────────────────────────────────────────────── -->
<div *ngIf="showEmailModal"
    class="fixed inset-0 z-50 flex items-center justify-center p-4"
    (click)="closeEmailModal()">

    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Modal card -->
    <div class="relative w-full max-w-md rounded-2xl bg-white shadow-2xl dark:bg-gray-900"
        (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-5 border-b border-gray-100 dark:border-gray-800">
            <div class="flex items-center gap-3">
                <!-- Back arrow on OTP step -->
                <button *ngIf="modalStep === 'otp'" (click)="goBackToEmail()"
                    class="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-500">
                    <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M19 12H5M12 5l-7 7 7 7"/>
                    </svg>
                </button>
                <div>
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                        {{ modalStep === 'email' ? 'Change Email Address' : 'Verify New Email' }}
                    </h3>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                        {{ modalStep === 'email'
                            ? 'Enter the new email address for your account'
                            : 'Enter the 6-digit code sent to ' + newEmail }}
                    </p>
                </div>
            </div>
            <button (click)="closeEmailModal()"
                class="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-400">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="px-6 py-6">

            <!-- STEP 1: Enter new email -->
            <ng-container *ngIf="modalStep === 'email'">
                <div class="mb-1">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                        Current Email
                    </label>
                    <div class="h-11 flex items-center px-4 rounded-lg bg-gray-50 border border-gray-200 text-sm text-gray-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400">
                        {{ currentEmail || '—' }}
                    </div>
                </div>

                <div class="mt-4">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
                        New Email Address
                    </label>
                    <input
                        type="email"
                        [(ngModel)]="newEmail"
                        (keyup.enter)="submitNewEmail()"
                        placeholder="Enter new email address"
                        class="h-11 w-full rounded-lg border px-4 text-sm outline-none transition-colors
                               border-gray-300 bg-white text-gray-900 placeholder-gray-400
                               focus:border-[#D31148] focus:ring-2 focus:ring-[#D31148]/10
                               dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
                        [class.border-red-400]="emailError"
                        [class.focus\:border-red-400]="emailError">
                    <p *ngIf="emailError" class="mt-1.5 text-xs text-red-500 flex items-center gap-1">
                        <svg class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                        {{ emailError }}
                    </p>
                </div>

                <button (click)="submitNewEmail()" [disabled]="emailLoading"
                    class="mt-5 w-full h-11 rounded-xl bg-[#D31148] text-white text-sm font-semibold
                           hover:bg-[#b80e3d] transition-colors disabled:opacity-60 disabled:cursor-not-allowed
                           flex items-center justify-center gap-2">
                    <svg *ngIf="emailLoading" class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" stroke-linecap="round"/>
                    </svg>
                    {{ emailLoading ? 'Sending code...' : 'Send Verification Code' }}
                </button>
            </ng-container>

            <!-- STEP 2: Enter OTP -->
            <ng-container *ngIf="modalStep === 'otp'">

                <!-- 6 OTP boxes -->
                <div class="flex items-center justify-center gap-2 sm:gap-3 my-2" (paste)="onOtpPaste($event)">
                    <input *ngFor="let digit of otpDigits; let i = index"
                        [id]="'otp-' + i"
                        type="text"
                        inputmode="numeric"
                        maxlength="1"
                        [value]="digit"
                        (input)="onOtpInput($event, i)"
                        (keydown)="onOtpKeydown($event, i)"
                        class="h-12 w-10 sm:w-12 rounded-xl border text-center text-xl font-bold outline-none transition-all
                               border-gray-300 bg-white text-gray-900
                               focus:border-[#D31148] focus:ring-2 focus:ring-[#D31148]/15
                               dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                        [class.border-[#D31148]]="digit !== ''"
                        [class.border-red-400]="otpError">
                </div>

                <p *ngIf="otpError" class="mt-2 text-center text-xs text-red-500 flex items-center justify-center gap-1">
                    <svg class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    {{ otpError }}
                </p>

                <button (click)="submitOtp()" [disabled]="otpLoading || !otpComplete"
                    class="mt-5 w-full h-11 rounded-xl bg-[#D31148] text-white text-sm font-semibold
                           hover:bg-[#b80e3d] transition-colors disabled:opacity-60 disabled:cursor-not-allowed
                           flex items-center justify-center gap-2">
                    <svg *ngIf="otpLoading" class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" stroke-linecap="round"/>
                    </svg>
                    {{ otpLoading ? 'Verifying...' : 'Verify & Update Email' }}
                </button>

                <!-- Resend -->
                <p class="mt-4 text-center text-sm text-gray-500 dark:text-gray-400">
                    Didn't receive the code?
                    <button (click)="resendOtp()" [disabled]="resendCooldown > 0 || emailLoading"
                        class="ml-1 font-semibold transition-colors"
                        [class.text-[#D31148]]="resendCooldown === 0 && !emailLoading"
                        [class.hover\:underline]="resendCooldown === 0 && !emailLoading"
                        [class.text-gray-400]="resendCooldown > 0 || emailLoading"
                        [class.cursor-not-allowed]="resendCooldown > 0 || emailLoading">
                        {{ resendCooldown > 0 ? 'Resend in ' + resendCooldown + 's' : 'Resend Code' }}
                    </button>
                </p>
            </ng-container>

        </div>
    </div>
</div>

<!-- ── Change Password Modal ─────────────────────────────────────────────── -->
<div *ngIf="showPasswordModal"
    class="fixed inset-0 z-50 flex items-center justify-center p-4"
    (click)="closePasswordModal()">

    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Modal card -->
    <div class="relative w-full max-w-md rounded-2xl bg-white shadow-2xl dark:bg-gray-900"
        (click)="$event.stopPropagation()">

        <!-- Header -->
        <div class="flex items-center justify-between px-6 py-5 border-b border-gray-100 dark:border-gray-800">
            <div>
                <h3 class="text-base font-semibold text-gray-900 dark:text-white">Change Password</h3>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Enter your current password to set a new one</p>
            </div>
            <button (click)="closePasswordModal()"
                class="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-400">
                <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="px-6 py-6 space-y-4">

            <!-- Current Password -->
            <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Current Password</label>
                <div class="relative">
                    <input
                        [type]="showCurrentPw ? 'text' : 'password'"
                        [ngModel]="currentPassword"
                        (ngModelChange)="currentPassword = stripSpaces($event)"
                        (keydown.space)="$event.preventDefault()"
                        placeholder="Enter current password"
                        class="h-11 w-full rounded-lg border px-4 pr-11 text-sm outline-none transition-colors
                               border-gray-300 bg-white text-gray-900 placeholder-gray-400
                               focus:border-[#D31148] focus:ring-2 focus:ring-[#D31148]/10
                               dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
                        [class.border-red-400]="pwCurrentError">
                    <button type="button" (click)="showCurrentPw = !showCurrentPw"
                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        <svg *ngIf="!showCurrentPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                        </svg>
                        <svg *ngIf="showCurrentPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                    </button>
                </div>
                <p *ngIf="pwCurrentError" class="mt-1.5 text-xs text-red-500 flex items-center gap-1">
                    <svg class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                    {{ pwCurrentError }}
                </p>
            </div>

            <!-- New Password -->
            <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">New Password</label>
                <div class="relative">
                    <input
                        [type]="showNewPw ? 'text' : 'password'"
                        [ngModel]="newPassword"
                        (ngModelChange)="newPassword = stripSpaces($event)"
                        (keydown.space)="$event.preventDefault()"
                        placeholder="Enter new password"
                        class="h-11 w-full rounded-lg border px-4 pr-11 text-sm outline-none transition-colors
                               border-gray-300 bg-white text-gray-900 placeholder-gray-400
                               focus:border-[#D31148] focus:ring-2 focus:ring-[#D31148]/10
                               dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
                        [class.border-red-400]="pwNewError">
                    <button type="button" (click)="showNewPw = !showNewPw"
                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        <svg *ngIf="!showNewPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                        </svg>
                        <svg *ngIf="showNewPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                    </button>
                </div>

                <!-- Strength bar -->
                <div *ngIf="newPassword" class="mt-2">
                    <div class="flex gap-1 mb-1">
                        <div *ngFor="let i of [0,1,2,3,4]"
                            class="h-1 flex-1 rounded-full transition-all duration-300"
                            [style.background-color]="i < passwordStrength.score ? passwordStrength.color : '#e5e7eb'">
                        </div>
                    </div>
                    <p class="text-xs font-medium" [style.color]="passwordStrength.color">
                        {{ passwordStrength.label }}
                    </p>
                </div>

                <p *ngIf="pwNewError" class="mt-1.5 text-xs text-red-500 flex items-center gap-1">
                    <svg class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                    {{ pwNewError }}
                </p>
            </div>

            <!-- Confirm Password -->
            <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">Confirm New Password</label>
                <div class="relative">
                    <input
                        [type]="showConfirmPw ? 'text' : 'password'"
                        [ngModel]="confirmPassword"
                        (ngModelChange)="confirmPassword = stripSpaces($event)"
                        (keydown.space)="$event.preventDefault()"
                        (keyup.enter)="submitChangePassword()"
                        placeholder="Confirm new password"
                        class="h-11 w-full rounded-lg border px-4 pr-11 text-sm outline-none transition-colors
                               border-gray-300 bg-white text-gray-900 placeholder-gray-400
                               focus:border-[#D31148] focus:ring-2 focus:ring-[#D31148]/10
                               dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500"
                        [class.border-red-400]="pwConfirmError"
                        [class.border-green-400]="!pwConfirmError && confirmPassword && confirmPassword === newPassword">
                    <button type="button" (click)="showConfirmPw = !showConfirmPw"
                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        <svg *ngIf="!showConfirmPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                        </svg>
                        <svg *ngIf="showConfirmPw" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                    </button>
                    <!-- Match checkmark -->
                    <svg *ngIf="!pwConfirmError && confirmPassword && confirmPassword === newPassword"
                        class="absolute right-9 top-1/2 -translate-y-1/2 h-4 w-4 text-green-500"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <polyline points="20 6 9 17 4 12"/>
                    </svg>
                </div>
                <p *ngIf="pwConfirmError" class="mt-1.5 text-xs text-red-500 flex items-center gap-1">
                    <svg class="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                    {{ pwConfirmError }}
                </p>
            </div>

            <!-- Submit -->
            <button (click)="submitChangePassword()" [disabled]="pwLoading"
                class="w-full h-11 rounded-xl bg-[#D31148] text-white text-sm font-semibold
                       hover:bg-[#b80e3d] transition-colors disabled:opacity-60 disabled:cursor-not-allowed
                       flex items-center justify-center gap-2">
                <svg *ngIf="pwLoading" class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4" stroke-dashoffset="10" stroke-linecap="round"/>
                </svg>
                {{ pwLoading ? 'Updating...' : 'Update Password' }}
            </button>

        </div>
    </div>
</div>
